import { render, staticRenderFns } from "./GoToTop.vue?vue&type=template&id=548c2676&scoped=true&"
import script from "./GoToTop.vue?vue&type=script&lang=js&"
export * from "./GoToTop.vue?vue&type=script&lang=js&"
import style0 from "./GoToTop.vue?vue&type=style&index=0&id=548c2676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c2676",
  null
  
)

export default component.exports